<template>
    <div class="app">
      <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
      <v-sheet v-show="showSkeleton" class="pa-3">
        <v-row>
          <v-col v-for="item in 4" :key="item">
            <v-skeleton-loader class="mx-auto" type="list-item" />
          </v-col>
        </v-row>
        <v-row>
          <v-col v-for="item in 4" :key="item">
            <v-skeleton-loader class="mx-auto" type="list-item" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-skeleton-loader class="mx-auto" type="button" />
          </v-col>
        </v-row>
        <v-row>
          <v-col v-for="item in 2" :key="item">
            <v-skeleton-loader class="mx-auto" type="image" height="220" />
          </v-col>
        </v-row>
      </v-sheet>
      <v-form ref="form" v-show="!showSkeleton">
        <v-row>
          <v-col cols="4">
            <v-text-field
              dense
              :value="form.description.toUpperCase()"
              :error-messages="descriptionErrors"
              :counter="30"
              label="Descrição"
              outlined
              @input="
                $v.form.description.$touch()
                form.description = $event.toUpperCase().trim()
              "
              @blur="$v.form.description.$touch()"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              dense
              v-model="form.usuario"
              :error-messages="usuarioErrors"
              label="Usuário"
              outlined
              @input="
                $v.form.usuario.$touch()
                form.usuario = $event.trim()
              "
              @blur="$v.form.usuario.$touch()"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              dense
              v-model="form.senha"
              :error-messages="senhaErrors"
              label="Senha"
              outlined
              @input="
                $v.form.senha.$touch()
                form.senha = $event.trim()
              "
              @blur="$v.form.senha.$touch()"
              :type="show ? 'text' : 'password'"
              @click:append="show = !show"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-select
              dense
              v-model="form.dtmf"
              :error-messages="dtmfErrors"
              :items="dtmf"
              outlined
              label="DTMF"
              @input="$v.form.dtmf.$touch()"
              @blur="$v.form.dtmf.$touch()"
            />
          </v-col>
        </v-row>
        <!-- <v-checkbox dense v-model="form.nat" label="nat" /> -->
        <p class="text-h9 d-inline pl-2">Nat</p>

          <v-row class="ml-1">
            <!-- <v-col cols="6"> -->
                <v-checkbox
                  v-model="form.nat"
                  label="Sim"
                  value="true"
                ></v-checkbox> 
                <v-checkbox
                  v-model="form.nat"
                  label="Não"
                  value="false"
                  class="ml-3"
                ></v-checkbox>
            <!-- </v-col> -->
            
          </v-row>
        <v-row>
         
          <v-col>
            <DraggAndDrop
              dragname="Codecs"
              :valoresDisponiveisComboBox="codecs.codecsDisponiveis"
              @dragUpdate="updateCodecs($event)"
              :opcoes-selecionadas="codecs.codecsSelecionadas"
            />
          </v-col>
          <v-col v-show="!form.interno">
            <DraggAndDrop
              dragname="Rotas"
              :valoresDisponiveisComboBox="rotasGerais.rotasGeralDisponiveis"
              @dragUpdate="updateRotasGeral($event)"
              :opcoesSelecionadas="rotasGerais.rotasGeralSelecionadas"
            />
          </v-col>
        </v-row>
        <v-divider dark vertical />
        <v-divider dark />
        <v-divider dark vertical />
        <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
      </v-form>
    </div>
  </template>
  
  <script>
  import { mapActions, mapGetters } from 'vuex'
  import { validationMixin } from 'vuelidate'
  import Snackbar from '@/componentes/Snackbar'
  import FixedButtons from '@/componentes/FixedButtons'
  import { registerVuexModule, formatarRota } from '@/utils/vuexUtils'
  import { ordenar } from '@/utils/ordenarArrayByText'
  import DraggAndDrop from '../_components/DraggAndDrop'
  import troncosStore from '../_store'
  import { validateData, validateComputed } from '../_validates/validateSipProxy'
  import TroncosHttpService from '../_services/TroncosHttpService'
  
  export default {
    name: 'AbaRamalPjsip',
    props: {
      edicao: String,
      _id: String,
    },
    components: { Snackbar, DraggAndDrop, FixedButtons },
    mixins: [validationMixin],
    data: () => ({
      form: {
        description: '',
        tipo: 'SIP-PROXY',
        usuario: '',
        senha: '',
        codecs: [],
        dtmf: 'rfc2833',
        nat: 'true',
        interno: false,
        rota: [],
      },
      rotasGerais: {
        rotasGeralDisponiveis: [],
        rotasGeralSelecionadas: [],
      },
      codecs: {
        codecsDisponiveis: ['alaw', 'ulaw', 'gsm', 'g729', 'h264', 'h263'],
        codecsSelecionadas: [],
      },
      dtmf: ['rfc2833', 'inband', 'info'],
      show: false,
      text: '',
      snackbar: false,
      showSkeleton: true,
      pararLoader: {
        parar: false,
      },
    }),
  
    validations: {
      ...validateData,
    },
  
    computed: {
      ...mapGetters('abaTroncoPJSIPModulePABXStore', ['getRotasDisponiveis', 'getTroncoSelecionado']),
      ...validateComputed,
    },
  
    async created() {
      registerVuexModule(this.$store, 'abaTroncoPJSIPModulePABXStore', troncosStore)
  
      await this.listarRotas()
  
      this.rotasGerais.rotasGeralDisponiveis = [...this.getRotasDisponiveis]
  
      if (this.edicao === 'true') {
        this.form = this.getTroncoSelecionado
  
        const arrayrotasSelecionadas = Object.values(this.getTroncoSelecionado.rota)
  
        arrayrotasSelecionadas.forEach(rotasSelecionadas => {
          const indexRotaGeral = this.rotasGerais.rotasGeralDisponiveis.findIndex(
            rotaGeral => rotaGeral._id === rotasSelecionadas
          )
  
          if (indexRotaGeral !== -1) {
            this.rotasGerais.rotasGeralSelecionadas.push(this.rotasGerais.rotasGeralDisponiveis[indexRotaGeral])
          }
        })
  
        if (typeof this.form.codecs !== 'undefined') {
          this.codecs.codecsSelecionadas = [...this.form.codecs]
        }
      } else {
        this.form.senha = this.keyGenerate()
        this.codecs.codecsSelecionadas.push('alaw', 'ulaw', 'gsm', 'g729')
        this.rotasGerais.rotasGeralSelecionadas = this.getRotasDisponiveis.filter(rota => rota.default)
      }
  
      ordenar(this.rotasGerais.rotasGeralDisponiveis)
      ordenar(this.codecs.codecsDisponiveis)
      this.showSkeleton = false
    },
  
    methods: {
      ...mapActions('abaTroncoPJSIPModulePABXStore', ['listarRotas']),
      updateCodecs(event) {
        this.form.codecs = event
      },
      updateRotasGeral(event) {
        this.form.rota = formatarRota(event)
      },
      async salvar() {
        this.pararLoader.parar = false
  
        if (!this.form.codecs.length) {
          this.text = 'Nenhum codec Selecionado'
          this.snackbar = true
          this.pararLoader.parar = true
          return
        } else if (!this.form.rota['1']) {
          this.text = 'Nenhuma rota selecionada.'
          this.snackbar = true
          this.pararLoader.parar = true
          return
        }
  
        this.$v.$touch()
        if (this.$v.$error) {
          this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
          this.pararLoader.parar = true
          return
        }
  
        try {
          if (this.edicao === 'true') {
            await TroncosHttpService.putTronco(this.form)
          } else {
            console.log(this.form)
            await TroncosHttpService.postTronco(this.form)
          }
  
          this.$router.push({ name: 'Troncos' })
        } catch (error) {
          this.text = error.response.data
          this.snackbar = true
          this.pararLoader.parar = true
        }
      },
      cancelar() {
        this.$router.push({ name: 'Troncos' })
      },
      keyGenerate() {
        const upperLetter = `ABCDEFGHIJKLMNOPQRSTUVYXWZ`
        const lowerLetter = `abcdefghijklmnopqrstuvyxwz`
        const numbers = `0123456789`
        const specialCharacters = `!#$?%*`

        const shuffleUpperLetter = this.shuffle(upperLetter).substr(0, 2)
        const shuffleLowerLetter = this.shuffle(lowerLetter).substr(0, 2)
        const shuffleNumbers = this.shuffle(numbers).substr(0, 2)
        const shuffleSpecialCharacters = this.shuffle(specialCharacters).substr(0, 2)

        const keyUnique = `${shuffleUpperLetter}${shuffleLowerLetter}${shuffleNumbers}${shuffleSpecialCharacters}`

        return this.shuffle(keyUnique)
      },
      shuffle(string) {
        return string
          .split('')
          .sort(() => 0.5 - Math.random())
          .join('')
      },
    },
  }
  </script>
  
  <style scoped>
  .app {
    background-color: var(--v-background-base);
  }
  </style>
  